export default __webpack_public_path__ + "c590382422f2742d788b8066d7c10ed4.ttf";